/*
 * @Date: 2022-10-25 10:09:51
 * @LastEditors: guantingting
 * @LastEditTime: 2022-11-08 14:02:29
 */
export default [
  {
    path: '/rent/v2/app/aboutus',
    name: 'aboutus',
    component: () => import('@/pages/forapp/aboutus'),
    meta: { title: '关于我们'},
  },
  {
    path: '/rent/v2/app/helper',
    name: 'helper',
    component: () => import('@/pages/forapp/helper'),
    meta: { title: '房车小助手'},
  },
  {
    path: '/rent/v2/app/qualification',
    name: 'qualification',
    component: () => import('@/pages/forapp/qualification'),
    meta: { title: '业务资质'},
  },
  {
    path: '/rent/v2/app/qualificationImage',
    name: 'qualificationImage',
    component: () => import('@/pages/forapp/qualificationImage'),
    meta: { title: '经营资质'},
  }
]


// WEBPACK FOOTER //
// ./src/pages/forapp/forapp.js